import { render, staticRenderFns } from "./NewInviteUBA.vue?vue&type=template&id=6b11eb40&scoped=true&"
import script from "./NewInviteUBA.vue?vue&type=script&lang=js&"
export * from "./NewInviteUBA.vue?vue&type=script&lang=js&"
import style0 from "./NewInviteUBA.vue?vue&type=style&index=0&id=6b11eb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b11eb40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperHeader,VStepperItems,VStepperStep})
